import { render } from "./LangSelector.vue?vue&type=template&id=5e64db6e"
import script from "./LangSelector.vue?vue&type=script&lang=js"
export * from "./LangSelector.vue?vue&type=script&lang=js"

import "./LangSelector.vue?vue&type=style&index=0&id=5e64db6e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__